import { Grid, makeStyles } from "@material-ui/core";
import { useEffect, useRef, useState } from "react";
import Category from "../../actions/Catagory";
import Product from "../../actions/product";
import { Autocomplete, CircularProgress, MenuItem } from "@mui/material";
import Controls from "../controls/Controls";
import { Form, useForm } from "../customHelpers/useForm";
import produce from "immer";
import TextField from "@material-ui/core/TextField";
import CheckIcon from "@mui/icons-material/Check";

const initialFValues = {
  price: "",
  quantity: "",
  editing: false,
};
const useStyles = makeStyles((theme) => ({
  icon: {
    borderRadius: "50%",
    height: "40px",
    width: "40px",
  },
}));
const AddProduct = ({
  NotifyMessage,
  setOpenPopup,
  recordForEdit,
  setProducts,
  getProductData,
  id
}) => {
  useEffect(() => {
    if (recordForEdit !== null) {
      console.log(recordForEdit);
      setValues({
        ...recordForEdit,
      });
    }
  }, []);

  useEffect(() => {
    getAllRoles();
  }, []);
  const classes = useStyles();
  const { updateProductList } = Product();
  const [categories, setCategories] = useState([]);
  const { viewAllCatagories } = Category();
  const validate = (fieldValues = values) => {
    const temp = { ...errors };
    const regexEmail =
      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if ("name" in fieldValues)
      temp.name = fieldValues.name.length != 0 ? "" : "This field is required.";
    if ("email" in fieldValues)
      temp.email =
        regexEmail.test(fieldValues.email.toString().toLowerCase()) &&
        fieldValues.email.length != 0
          ? ""
          : "Email is not valid.";
    if ("description" in fieldValues)
      temp.description =
        fieldValues.description.length !== 0 ? "" : "This field is required.";
    if ("description" in fieldValues) {
      temp.description =
        fieldValues.description.length >= 4
          ? ""
          : "Description must be at least 4 characters.";
    }

    setErrors({
      ...temp,
    });
    if (fieldValues == values) return Object.values(temp).every((x) => x == "");
  };

  const { values, errors, setValues, handleInputChange, setErrors, resetForm } =
    useForm(initialFValues, true, validate);
  const getAllRoles = () => {
    viewAllCatagories().then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.categorys) {
        setCategories(data.categorys);
      }
    });
  };
  const [selectedOptions, setSelectedOptions] = useState([]);
  const handleChange = (event, newValue) => {
    setSelectedOptions(newValue.map((option) => option.name));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validate()) {
      setValues({ ...values, submitting: true });
      delete values.logginError;
      delete values.editing;
      updateProductList(values, values.id).then((data) => {
        if (data.err) {
          setValues({ ...values, submitting: false });
          NotifyMessage({
            message: data.err,
            type: "error",
          });
        } else {
          NotifyMessage({
            message: "Product List successfully updated",
            type: "success",
          });
          setOpenPopup(false);
          resetForm();
          getProductData(id);
        }
      });
    }
  };
   const firstFieldRef = useRef(null);
    useEffect(() => {
      if (firstFieldRef.current) {
        firstFieldRef.current.focus();
      }
    }, []);
  return (
    <Form onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Controls.Input
            name="quantity"
            label="Quantity"
            value={values.quantity}
            onChange={handleInputChange}
            error={errors.quantity}
            inputRef={firstFieldRef}

          />
        </Grid>

        <Grid item xs={12} md={6}>
          <Controls.Input
            name="price"
            label="Price"
            value={values.price}
            onChange={handleInputChange}
            error={errors.price}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <div>
            <Controls.Button
              disabled={values.submitting ? true : false}
              text={values.submitting ? "Editing..." : "Done"}
              variant="contained"
              className="Button"
              type="submit"
            />
            <Controls.Button
              text={"Cancel"}
              variant="contained"
              className="Button"
              onClick={() => {
               setOpenPopup(false)
              }}
            />
          </div>
        </Grid>
      </Grid>
    </Form>
  );
};

export default AddProduct;
